import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyDataComponent } from './empty-data.component';
import { UtilityService } from 'bbsf-utilities';



@NgModule({
  declarations: [EmptyDataComponent],
  imports: [
    CommonModule
  ],
  exports: [
    EmptyDataComponent
  ],
  providers:[
    UtilityService
  ]
})
export class EmptyDataModule { }
